<template>
  <v-alert
    v-if="provider"
    border="start"
    border-color="primary"
    color="white"
    icon="person_add"
    type="info"
    prominent
  >
    <div>
      <div class="fs-22 fw-500">
        {{ request.provider_name }}
      </div>
      <div class="fs-16 fw-500">
        {{ getProviderAddress() }}
      </div>
      <v-alert
        v-if="request.request_reason"
        color="white"
        icon="info"
      >
        <div>
          <p>{{ request.request_reason }}</p>
        </div>
      </v-alert>
    </div>
    <template #append>
      <v-chip
        size="large"
        variant="outlined"
        label
      >
        {{ $bct('Pending') }}
      </v-chip>
      <v-btn
        @click="destroyRequest()"
        class="ms-3"
        icon="delete"
        variant="plain"
      />
    </template>
  </v-alert>

  <ConfirmDialog ref="confirmDialog" />
</template>

<script setup>
import Api from '@/manager/services/bright_finder.js';
import ConfirmDialog from '@/shared/components/ConfirmDialog.vue';
import { formatAddress } from '@/shared/services/address';
import useEventBus from '@/shared/composables/useEventBus';

const eventBus = useEventBus();

const $bct = inject('translator');

const props = defineProps({
  request: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['destroyed']);

const confirmDialog = ref(null);
const provider = ref(null);

onMounted(() => {
  loadProvider();
});

async function destroyRequest() {
  const confirmed = await confirmDialog.value.confirmWithText(
    'Are you sure you want to cancel this request?',
    {
      title: 'Cancel Request',
      confirmButtonText: 'Cancel Request',
      cancelButtonText: 'Keep Request',
      saveButtonColor: 'red',
    },
  );
  if (confirmed) {
    await Api.manager.accessRequest.destroy(props.request.id);
    emit('destroyed');
    eventBus.chime('Request canceled');
  }
}

function loadProvider() {
  Api.publicApi.provider.get(props.request.provider_id, (resp) => (provider.value = resp.data));
}

function getProviderAddress() {
  if (!provider.value) return null;
  return formatAddress(provider.value.address1, provider.value.city);
}
</script>
